import { HoverCard } from "@/components/overview/hover-card";
import { monthDay } from "@/lib/gantt";
import { css, cx } from "@styled-system/css";

interface MilestoneDiamondProps {
  text: string;
  due: string;
  open: boolean;
  /** Center of the due day, in px from the track's left edge. */
  x: number;
  /** The date falls outside the bar it belongs to. */
  outside: boolean;
  /** Ink class for the domain color. */
  ink: string;
}

const SIZE = 10;

const wrap = css({
  position: "absolute",
  top: "[50%]",
  zIndex: "[3]",
  transform: "translate(-50%, -50%)",
  pointerEvents: "auto",
});

const diamond = css({
  display: "block",
  w: "[10px]",
  h: "[10px]",
  transform: "rotate(45deg)",
  border: "[1.5px solid var(--oks-colors-text-bold)]",
  bg: "surface",
  outline: "none",
  cursor: "default",
  _focusVisible: { boxShadow: "[0 0 0 2px var(--oks-colors-border-focused)]" },
});

const filled = css({ bg: "text.bold" });

const warn = css({
  boxShadow: "[0 0 0 2px var(--oks-colors-surface), 0 0 0 3.5px var(--oks-colors-text-warning)]",
});

/** A 📅 task on its phase row. Hollow when open, filled when done, ringed when outside its bar. */
export function MilestoneDiamond({ text, due, open, x, outside, ink }: MilestoneDiamondProps) {
  const lines = [`📅 ${monthDay(due)} · ${open ? "open" : "done"}`];
  if (outside) lines.push("Outside this phase's plan");
  return (
    <div className={wrap} style={{ left: x, width: SIZE, height: SIZE }}>
      <HoverCard title={text} lines={lines}>
        <span
          // biome-ignore lint/a11y/noNoninteractiveTabindex: focus shows the hover card for keyboard users
          tabIndex={0}
          role="img"
          aria-label={`${text}, due ${monthDay(due)}${open ? "" : ", done"}${outside ? ", outside the plan" : ""}`}
          className={cx(diamond, ink, !open && filled, outside && warn)}
        />
      </HoverCard>
    </div>
  );
}
